module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZD0iTTAgMGg2NDB2MTYwSDB6IiBmaWxsPSJyZWQiLz4KICA8cGF0aCBkPSJNMCAxNjBoNjQwdjE2MEgweiIgZmlsbD0iIzAwZiIvPgogIDxwYXRoIGQ9Ik0wIDMyMGg2NDB2MTYwSDB6IiBmaWxsPSJvcmFuZ2UiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/am.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/am.svg
// module chunks = 0